import react from 'react';
import { useTranslation } from 'react-i18next';

import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';

import Wallet from '../plugin/Wallet';
import { Token } from '../plugin/config/tokens';

type PopupRegisterTokenProps = {
  wallet:Wallet;
  token:Token;
};

const PopupRegisterToken: react.FC<PopupRegisterTokenProps> = ({ wallet, token }) => {
  const { t } = useTranslation();

  const registerTokenClick: React.MouseEventHandler<HTMLElement> = (): void => {
    const { address, symbol, image, type, decimals } = token;

    wallet.callWatchAsset(address, symbol, type, decimals, image);
  };

  return (
    <ListItem className="popup-register-token-item">
      <ListItemAvatar className="popup-register-token-item-avatar-wrapper">
        <Avatar className="popup-register-token-item-avatar">
          <img className="popup-register-token-item-avatar-image" src={token.image} alt={token.symbol} />
        </Avatar>
      </ListItemAvatar>
      <ListItemText className="popup-register-token-item-text" primary={token.symbol} />
      <div className="popup-register-token-item-button-wrapper">
        <div className="popup-register-token-item-button material-button flat" onClick={registerTokenClick}>{t('form.registerToken')}</div>
      </div>
    </ListItem>
  );
};

export default PopupRegisterToken;
